(() => {
  const THIRD_PARTY_SOCIAL_PROOF_SELECTORS = [
    '.spr-badge',
    '.spr-container',
    '.spr-review',
    '.loox-rating',
    '.loox-reviews-default',
    '.product-reviews',
    '[data-product-reviews]',
  ];

  const TRUSTED_SOCIAL_PROOF_SELECTOR = [
    '.jdgm-widget',
    '.jdgm-preview-badge',
    '#judgeme_product_reviews',
    '.bpc-product-social-proof',
    '.bpc-store-rating',
    '.bpc-card-rating',
  ].join(',');

  const collect = (root, selector) => {
    const matches = [];
    if (root instanceof Element && root.matches(selector)) matches.push(root);
    if (root?.querySelectorAll) matches.push(...root.querySelectorAll(selector));
    return matches;
  };

  const cleanThirdPartySocialProof = (root = document) => {
    if (!root?.querySelectorAll && !(root instanceof Element)) return;
    if (root instanceof Element && root.closest(TRUSTED_SOCIAL_PROOF_SELECTOR)) return;

    collect(root, THIRD_PARTY_SOCIAL_PROOF_SELECTORS.join(','))
      .filter((element) => !element.closest(TRUSTED_SOCIAL_PROOF_SELECTOR))
      .forEach((element) => element.remove());
  };

  const init = () => {
    cleanThirdPartySocialProof(document);

    const pendingRoots = new Set();
    let frameId = 0;

    const flush = () => {
      frameId = 0;
      const roots = [...pendingRoots];
      pendingRoots.clear();
      roots.forEach((root) => {
        if (root.isConnected) cleanThirdPartySocialProof(root);
      });
    };

    const queueRoot = (root) => {
      if (!(root instanceof Element) || root.closest(TRUSTED_SOCIAL_PROOF_SELECTOR)) return;
      pendingRoots.add(root);
      if (!frameId) frameId = window.requestAnimationFrame(flush);
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => queueRoot(node));
      });
    });

    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
